import { useState } from "react";
import { toast } from "sonner";
import { CurrencyCircleDollar, Warning } from "@phosphor-icons/react";
import api, { apiError } from "../lib/api";

const CURRENCIES = [
  { code: "GNF", label: "Franc Guinéen", symbol: "GNF" },
  { code: "XOF", label: "Franc CFA (UEMOA)", symbol: "FCFA" },
  { code: "EUR", label: "Euro", symbol: "€" },
  { code: "USD", label: "Dollar US", symbol: "$" },
];

export function CurrencySection({ current, onChanged }) {
  const [target, setTarget] = useState(current || "GNF");
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const active = CURRENCIES.find((c) => c.code === (current || "GNF"));

  const apply = async () => {
    setBusy(true);
    try {
      const { data } = await api.patch("/company/currency", { currency: target });
      toast.success(`Devise changée en ${target} (taux appliqué : 1 ${data.previous} = ${data.rate?.toFixed(6)} ${target})`);
      setConfirming(false);
      onChanged?.();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="kcard p-5 space-y-3" data-testid="currency-section">
      <div className="flex items-start gap-2">
        <CurrencyCircleDollar size={20} className="shrink-0 mt-0.5" />
        <div>
          <h3 className="font-display font-bold">Devise de l'entreprise</h3>
          <p className="text-xs text-gray-500">
            Devise actuelle : <span className="font-semibold">{active?.label} ({active?.symbol})</span>. Toute votre activité s'affiche dans cette devise.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {CURRENCIES.map((c) => (
          <button key={c.code} data-testid={`settings-currency-${c.code}`}
            onClick={() => { setTarget(c.code); setConfirming(c.code !== (current || "GNF")); }}
            className={`p-3 rounded-2xl border text-left transition-colors ${target === c.code ? "border-[#C9793A] bg-[#C9793A]/5" : "border-[#E0DACE] bg-white"}`}>
            <span className="text-sm font-semibold block">{c.symbol}</span>
            <span className="text-xs text-gray-500">{c.code}</span>
          </button>
        ))}
      </div>

      {confirming && (
        <div data-testid="currency-confirm" className="space-y-2 bg-[#F7EFD9] text-[#8a6a14] rounded-xl px-3 py-2.5">
          <p className="text-sm flex items-start gap-1.5">
            <Warning size={15} className="shrink-0 mt-0.5" />
            Tous vos montants déjà enregistrés (ventes, dépenses, stock, salaires, créances et dettes) seront convertis
            en {target} avec un taux unique du jour. C'est une conversion approximative, elle ne reconstitue pas les taux
            historiques de chaque opération.
          </p>
          <div className="flex gap-2">
            <button className="btn-ghost flex-1 py-2.5 bg-white" onClick={() => { setTarget(current || "GNF"); setConfirming(false); }}>Annuler</button>
            <button data-testid="currency-apply-btn" className="btn-amber flex-1 py-2.5" disabled={busy} onClick={apply}>
              {busy ? "Conversion..." : `Convertir en ${target}`}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
